var _g, _g2, _g3, _g4, _g5, _path, _ellipse, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamlaHeroSymbolFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 190",
    width: 300,
    height: 190,
    fill: "none",
    role: "img",
    "aria-label": "Diagram symbol set connected as a process flow",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "connectors",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 40 H104",
    stroke: "#D9CFC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 40 H206",
    stroke: "#D9CFC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 126 H206",
    stroke: "#D9CFC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "branch-connector",
    d: "M138 74 V126 H98",
    stroke: "#E1C4B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206,40 200,37 200,43",
    fill: "#D9CFC6",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206,126 200,123 200,129",
    fill: "#D9CFC6",
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "symbol-process"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 25,
    width: 66,
    height: 30,
    rx: 6,
    fill: "#FBF3EE",
    stroke: "#C0674B",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "symbol-decision"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 19,
    width: 42,
    height: 42,
    rx: 4,
    fill: "#FBF3EE",
    stroke: "#C0674B",
    strokeWidth: 2,
    transform: "rotate(45 138 40)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "symbol-terminator"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 40,
    r: 19,
    fill: "#EEF1EE",
    stroke: "#6E9B7B",
    strokeWidth: 2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "symbol-input"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 111,
    width: 66,
    height: 30,
    rx: 3,
    fill: "#F0EEF6",
    stroke: "#6B5EA8",
    strokeWidth: 2,
    transform: "translate(64 126) skewX(-16) translate(-64 -126)"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "symbol-data-store",
    x: 132,
    y: 106,
    width: 46,
    height: 40,
    viewBox: "0 0 48 42",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9 V33 C3 37.4 12.4 40 24 40 C35.6 40 45 37.4 45 33 V9 Z",
    fill: "#FBF3EE",
    stroke: "#C0674B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 9,
    rx: 21,
    ry: 7,
    fill: "#FBF3EE",
    stroke: "#C0674B",
    strokeWidth: 2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "symbol-pending"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 111,
    width: 66,
    height: 30,
    rx: 6,
    fill: "#FDF8F5",
    stroke: "#E1C4B7",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamlaHeroSymbolFlow);
export default __webpack_public_path__ + "static/media/famla-hero-symbol-flow.c1cd841e8758cc4419d1d2c800600631.svg";
export { ForwardRef as ReactComponent };